import application from 'application/application';

import submenuTemplate from './partials/submenu/submenu.template.html';

import submenuController from './partials/submenu/submenu.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider.state('root.default.account', {
			abstract: true,
			url: '/minha-conta',
			views: {
				'submenu@root.default': {
					templateUrl: submenuTemplate,
					controller: submenuController
				}
			}
		});
	}
]);
